export { EmailController } from "./email";
export { InitController } from "./init";
export { AcademyInitOverviewController } from "./initacademy";
export { ReviewInitController } from "./initreview";
export { TestInitController } from "./inittest";
export { AcademyNavigationController } from "./navigation";
export { AcademyTestController } from "./testacademy";
